import { useEffect, useRef } from 'react'
import { useKeyboardVisibility } from './useKeyboardVisibility'
import { ScrollView, StyleProp, useWindowDimensions, ViewStyle } from 'react-native'

interface Args {
  handleKeyboardPadding: () => StyleProp<ViewStyle>
}

export const useMoveScroll = ({ handleKeyboardPadding }: Args) => {
  const { isKeyboardVisible, keyboardHeight } = useKeyboardVisibility()
  const { height } = useWindowDimensions()
  const scrollViewRef = useRef<ScrollView>(null)

  const handleKeyboardShow = () => {
    scrollViewRef.current &&
      scrollViewRef.current.scrollTo({
        y: height - keyboardHeight,
        animated: true,
      })
  }

  useEffect(() => {
    isKeyboardVisible && handleKeyboardShow()
  }, [isKeyboardVisible, handleKeyboardPadding])

  return { scrollViewRef }
}
